/* global ko */
IREP.Garage = (function () {
    var hoverTimeout = 500;

    var Garage = function () {
        var self = this;

        this.$garage = $('#garage');
        this.$market = $('#market');
        this.$astrocomm = this.$garage.find('.astrocomm');

        $('#footer').remove();
        self.insertUserInfo();
        self.levelUpdate();
        self.insertNewTools();
        self.updateInsertNewShip();
        //self.glowingBlue5();
        self.initialFunction();

        this.level = ko.observable();
        this.chips = ko.observable(0);

        this.bubbleImage = ko.computed(function () {
            return Math.floor(Math.random() * 5) + 1;
        });

        this.tools = ko.observableArray([]);
       
        this.selectedTool = ko.observable(null);

        this.parts = ko.observableArray([]);
        this.selectedPart = ko.observable(null);

        this.stash = ko.observableArray([]);
        this.selectedStash = ko.observable(null);

        this.shipSelection = ko.observableArray([]);

        this.pilotInfo = ko.observableArray();
        
        this.market = ko.observableArray();
        this.selectedMarketItem = ko.observable(null);

        this.ship = ko.observableArray();

        this.fuelBase = ko.observable(10);
        this.fuelSupply = ko.observable(0);
        this.fuelBought = ko.observable(0);

        this.fuel = ko.computed(function () {
            return self.fuelBase()+ self.fuelSupply() + self.fuelBought();
        });

        this.fuel.subscribe(function (value) {
            self.$garage.find('.controls .fuel .progress > div').width(value + '%');
        });
        
        this.chargeBase = ko.observable(5);
        this.chargeSupply = ko.observable(0);
        this.chargeBought = ko.observable(0);

        this.charge = ko.computed(function () {
            return self.chargeBase() + self.chargeSupply() + self.chargeBought()
        });

        this.charge.subscribe(function (value) {
            self.$garage.find('.controls .charge .progress > div').width(value + '%');
        });       
        
        this.shieldBase = ko.observable(10);
        this.shieldSupply = ko.observable(0);
        this.shieldBought = ko.observable(0);

        this.shield = ko.computed(function () {
            return self.shieldBase() + self.shieldSupply() + self.shieldBought()
        });

        this.shield.subscribe(function (value) {
            self.$garage.find('.controls .shield .progress > div').width(value + '%');
        });
        
        this.shieldType = ko.observable('-NONE-');

        this.costBase = ko.computed(function() {
            return self.fuel() + self.charge() + self.shield() -25;
        });
        this.costSupply = ko.observable(0);

        this.cost = ko.computed(function () {
            return self.costBase() - self.costSupply();
        });

        this.hover = ko.observable(null);
        this.hoverName = ko.computed(function () {
            return self.hover() !== null ? self.hover().name() : '-NONE-';
        });
        this.hoverDistance = ko.computed(function () {
            return self.hover() !== null ? Garage.numberWithCommas(self.hover().distance()) : '0';
        });
        this.hoverLevelRequired = ko.computed(function () {
            return self.hover() !== null ? self.hover().level() : '0';
        });
        this.hoverAccess = ko.computed(function () {
            if (self.hover() !== null) {
                if ((self.level() >= self.hover().level()) && (self.hover().name() !== 'Titan')) {
                    return '-GRANTED-';
                }
                else if ((self.hover().name() === 'Titan') && (self.level() >= self.hover().level()) && (self.ship()[0].id() === 19 || self.ship()[0].id() === 20)) {
                    return '-GRANTED-';
                }
                else {
                    return '-DENIED-';
                }            
            }

            return '-NONE-';
        });


        this.visit = ko.observable(null);
        this.visitName = ko.computed(function () {
            return self.visit() !== null ? self.visit().name() : '-NONE-';
        });
        this.visitDistance = ko.computed(function () {
            return self.visit() !== null ? Garage.numberWithCommas(self.visit().distance()) : '0';
        });
        this.visitLevelRequired = ko.computed(function () {
            return self.visit() !== null ? self.visit().level() : '0';
        });
        this.visitAccess = ko.computed(function () {
            if (self.visit() !== null) {
                if (self.level() >= self.visit().level()) {
                    return '-GRANTED-';
                } else {
                    return '-DENIED-';
                }
            }

            return '-NONE-';
        });

        this.target = ko.observable(null);
        this.targetName = ko.computed(function() {
            return self.target() !== null ? self.target().name() : '-NONE-';
        });
        this.targetDistance = ko.computed(function() {
            return self.target() !== null ? Garage.numberWithCommas(self.target().distance()) : '0';
        });
        this.targetLevelRequired = ko.computed(function() {
            return self.target() !== null ? self.target().level() : '0';
        });
        this.targetAccess = ko.computed(function() {
            if (self.target() !== null) {
                if (self.level() >= self.target().level()) {
                    return '-GRANTED-';
                } else {
                    return '-DENIED-';
                }
            }

            return '-NONE-';
        });
        
        this.targets = ko.observableArray([]);

        this.canLaunch = ko.computed(function () {            
            var fuel = self.fuel();
            var charge = self.charge();
            var shield = self.shield();
            var shieldType = self.shieldType();
            var target = self.target();
            var level = self.level();
            var ship = self.ship();

            var chipsAvailable = 0;

            if (self.pilotInfo()[0] !== undefined) {
                if (self.pilotInfo()[0].totalPoints !== undefined) {
                    chipsAvailable = self.pilotInfo()[0].totalPoints();
                }
            }
           
            if (fuel > (self.fuelBase() + self.fuelSupply()) && charge > (self.chargeBase() + self.chargeSupply()) && shield > (self.shieldBase() + self.shieldSupply()) && shieldType !== '-NONE-' && target !== null && level >= target.level() && ship.length > 0 && chipsAvailable >= self.cost() && target.name() !== 'Titan' && self.shipSelection().length === 0) {
                return true;
            }
            else if (fuel > (self.fuelBase() + self.fuelSupply()) && charge > (self.chargeBase() + self.chargeSupply()) && shield > (self.shieldBase() + self.shieldSupply()) && shieldType !== '-NONE-' && target !== null && level >= target.level() && ship.length > 0 && chipsAvailable >= self.cost() && target.name() === 'Titan' && (ship[0].id() === 19 || ship[0].id() === 20) && self.shipSelection().length === 0) {
                return true;
            }

            return false;
        });

        $('.bubble-tow').on('click', function () {
            $('.bubble-tow').hide();
        });

        $('.bubbleImg').on('click', function () {
            $('.bubbleImg').hide();
        });

        this.mission = ko.observable(null);

        this.$garage.find('[data-nav]').on('click', this.gotoMainLandingPage);
        this.$market.find('[data-nav]').on('click', this.gotoMainLandingPage);      

        this.introSound = ['/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 1.mp3'];
        this.lunaticSounds = ['/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 1.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 2.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 3.mp3','/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 4.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 5.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 6.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 7.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 8.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 9.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 10.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 11.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 12.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 13.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 14.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 15.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 16.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 17.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 18.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 19.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 20.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/Lunatic 21.mp3'];

        this.blue5Success = ['/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 5.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 6.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 7.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 8.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 9.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 10.mp3'];

        this.blue5Failure = ['/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 2.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 3.mp3', '/Content/Images/ASMO/2015SWIC/garage/audio/BlueFive 4.mp3'];

        this.howl = null;     

        ko.applyBindings(this);

        try {
            _gaq.push(['_setCustomerVar', 3, 'HANGAR', 'yes', 1]);
            _gaq.push(['_setCustomerVar', 4, 'HANGAR', 'yes', 2]);
            _gaq.push(['_trackEvent', 'HANGAR', 'visit']);
        } catch (e) { }
    };

    Garage.prototype.track = function (type, label, value, data) {
        IREP.track('GARAGE', type, label, value, data);
        try {
            _gaq.push(['_trackEvent', 'GARAGE', type, label, value]);
        } catch (e) { }
    };

    Garage.prototype.trackMessage = function(label, value, data) {
        this.track('message', label, value, data);
    };

    Garage.prototype.trackVisit = function(label, value, data) {
        this.track('visit', label, value, data);
    };

    Garage.prototype.trackTarget = function (label, value, data) {
        this.track('target', label, value, data);
    };

    Garage.prototype.trackTutorial = function (label, value, data) {
        this.track('tutorial', label, value, data);
    };

    Garage.prototype.trackMenu = function(label, value, data) {
        this.track('menu', label, value, data);
    };

    Garage.prototype.trackChart = function (label, value, data) {
        this.track('chart', label, value, data);
    };

    Garage.prototype.openBlue5Message = function (data, event) {
        $('.messageList').css('display', 'none');
        $('.messageList').removeClass('opened');       
        event = event || window.event;
        var target = event.target || event.srcElement;

        if ($(target).hasClass('introMsg')) {           
            $('.intro').addClass('opened');
            $('.intro').css('display', 'block');
            $('.page1').addClass('opened');
            $('.page1').css('display', 'block');
            $('footer').css('display', 'block');
            $('.prev').css('visibility', 'visible');
            $('.next').css('visibility', 'visible');
        }
        else if ($(target).hasClass('lvl2')) {
            $('.lvl2msg').addClass('opened');
            $('.lvl2msg').css('display', 'block');
            $('.footer').css('display', 'block');
            $('.prev').css('visibility', 'visible');
            $('.next').css('visibility', 'hidden');
            this.trackTutorial('lvl2msg');
        }
        else if ($(target).hasClass('lvl3')) {
            $('.lvl3msg').addClass('opened');
            $('.lvl3msg').css('display', 'block');
            $('.footer').css('display', 'block');
            $('.prev').css('visibility', 'visible');
            $('.next').css('visibility', 'hidden');
            this.trackTutorial('lvl3msg');
        }
        else if ($(target).hasClass('lvl4')) {
            $('.lvl4msg').addClass('opened');
            $('.lvl4msg').css('display', 'block');
            $('.footer').css('display', 'block');
            $('.prev').css('visibility', 'visible');
            $('.next').css('visibility', 'hidden');
            this.trackTutorial('lvl4msg');
        }
        else if ($(target).hasClass('lvl5')) {
            $('.lvl5msg').addClass('opened');
            $('.lvl5msg').css('display', 'block');
            $('.footer').css('display', 'block');
            $('.prev').css('visibility', 'visible');
            $('.next').css('visibility', 'hidden');
            this.trackTutorial('lvl4msg');
        }
    };

    Garage.prototype.goToTheNextPage = function () {
        var page = $('#garage').find('.message .intro > div.opened');
        if (page.length !== 0) {
            var className = $(page)[0].className;
            var num = parseInt(className.substring(4, 6)) + 1;

            if (num  === 11) {
                $('.next').css('visibility', 'hidden');
            }            
            else {
                $('.next').css('visibility', 'visible');
            }           

            if (num !== 12) {
                $(page).removeClass('opened');
                $('.page' + num).addClass('opened');
                this.messageScreenToggle('intro','page' + num);
                this.trackTutorial('page' + num);
                this.glowTutorial(num);
            }
        }
        else {
            $(page).removeClass('opened');
            $('.page1').addClass('opened');
            this.messageScreenToggle('intro','page1');
            $('.prev').css('visibility', 'hidden');
            this.glowTutorial(1);
            this.trackTutorial('page1');
        }
    };
    
    Garage.prototype.goToThePrevPage = function () {
        var page = $('#garage').find('.message .intro > div.opened');
        var lvlMsg = $('#garage').find('.message div.opened');

        if (page.length!== 0) {
            var className = $(page)[0].className;
            var num = parseInt(className.substring(4, 6)) - 1;

            if (num === 0) {
                this.$garage.find('.opened').css('display', 'none').removeClass('opened');
                $('.messageList').css('display', 'block');
                $('.messageList').addClass('opened');
                $('footer').hide();
            }

            if (num <= 10) {
                $('.next').css('visibility', 'visible');
            }

            if (num !==0) {
                $(page).removeClass('opened');
                $('.page' + num).addClass('opened');
                this.messageScreenToggle('intro','page' + num);
                this.trackTutorial('page' + num);
                this.glowTutorial(num);
            }
        }
        else if (lvlMsg.length !==0){
            this.$garage.find('.opened').css('display', 'none').removeClass('opened');
            $('.messageList').css('display', 'block');
            $('.messageList').addClass('opened');
            $('footer').hide();
        }       
    };

    Garage.prototype.messageScreenToggle = function (parentMsg, msg) {
        this.$garage.find('.message  div:not([class=opened])').hide();
        this.$garage.find('.message  .' + parentMsg).show()
        this.$garage.find('.message  .' + msg).show();
    };

    Garage.prototype.glowTutorial = function (item) {
        var page = $('#garage').find('.tutorial');

        if (page.length > 0) {
            $(page).removeClass('tutorial');
        }        
       
        if (item === 4) {
            $('.step4').addClass('tutorial');
        }
        else if (item === 5) {            
            $('.tools').addClass('tutorial');
        }
        else if (item === 6) {
            $('.step5').addClass('tutorial');          
        }
        else if (item === 7) {
            $('.screenToggle:nth-child(3)').addClass('tutorial');
        }
        else if (item === 8) {
            $('.step8').addClass('tutorial');
        }
        else if (item === 9) {           
            $('.fuel').addClass('tutorial');
            $('.charge').addClass('tutorial');
            $('.shield').addClass('tutorial');
        }
        else if (item === 10) {
            $('.launch').addClass('tutorial');
        }
        else if (item === 11) {
            $('.stash').addClass('tutorial');
        }
    };

    Garage.prototype.playSound = function (file) {
        if (this.howl !== null) {
            this.howl.stop();
            this.howl = null;
        }

        this.howl = new Howl({
            urls: [file]
        });

        this.howl.play();
    }

    Garage.prototype.delay = function (timeout) {
        var deferred = $.Deferred();

        setTimeout(function () {
            deferred.resolve();
        }, timeout);

        return deferred.promise();
    };

    Garage.numberWithCommas = function(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    Garage.prototype.gotoMainLandingPage = function () {
        if ($(this).data('nav') !== 'garage') {
            window.location.href = IREP.options.appUrl + 'asmo/swic/' + $(this).data('nav');
        }
    };

    Garage.prototype.openMessage = function () {
        var self = this;
        self.stopGlowing();

        if (self.level() === 5) {
            $('.introMsg').addClass('granted');
            $('.lvl5').addClass('granted');
        }
        else if (self.level() === 4) {
            $('.introMsg').addClass('granted');
            $('.lvl4').addClass('granted');
        }
        else if (self.level() === 3) {
            $('.introMsg').addClass('granted');
            $('.lvl3').addClass('granted');
        }
        else if (self.level() === 2) {
            $('.introMsg').addClass('granted');
            $('.lvl2').addClass('granted');
        }
        else {
            $('.introMsg').addClass('granted');
        }

        this.$garage.find('.opened').css('display', 'none').removeClass('opened');
        $('footer').hide();
        $('.messageList').css('display', 'block');
        $('.messageList').addClass('opened');
        this.trackMessage('open');

        var soundFile = this.introSound[Math.floor(Math.random() * this.introSound.length)];

        this.playSound(soundFile);

        $('.open').removeClass('open');
        this.$garage.find('.message').toggleClass('open');
    };

    Garage.prototype.openHome = function () {
        $('.open').removeClass('open');
        this.$garage.find('.home').toggleClass('open');
        this.$market.find('.home').toggleClass('open');
    };

    Garage.prototype.openHangar = function () {
        this.$garage.find('.home').removeClass('open');
        this.$market.find('.home').removeClass('open');
        this.$market.hide();
        this.$garage.show();
    };

    Garage.prototype.openVendor = function () {
        if ($('.vendor').hasClass('active')) {
            this.$market.show();
            this.$garage.hide();

            var soundFile = this.lunaticSounds[Math.floor(Math.random() * this.lunaticSounds.length)];

            this.playSound(soundFile);
        }
        else {
            $('.vendor').hide();
        }
        $('.bubbleImg').hide();
    };

    Garage.prototype.glowingBlue5 = function () {
        $('.btnGlow').css('display', 'inline');
        $('.outerGlow').css('display', 'inline');

        function pulsate(element) {
            $('.btnGlow').css('opacity', 1);
            $(element || this).css('opacity', 0);

            $('.outerGlow').animate({ opacity: 1 }, 1000, function () {
                $('.outerGlow').animate({ opacity: 0 }, 1000, pulsate);
            });
        };

        pulsate('.blue5');
    };

    Garage.prototype.stopGlowing = function () {
        $('.btnGlow').hide();
        $('.outerGlow').hide();
        $('.blue5').css('opacity', 1);
    };

    Garage.prototype.openScreen = function () {
        $('.open').removeClass('open');
        this.$garage.find('.tutorial').removeClass('tutorial');
        this.$garage.find('.opened').css('display', 'none').removeClass('opened');

        this.$garage.find('.screen').toggleClass('open');

        this.$astrocomm.find('> .screenToggle').toggleClass('open');
    };

    Garage.prototype.closeScreen = function() {
        $('.open').removeClass('open');
    };

    Garage.prototype.openMenu = function (d, e) {
        this.$garage.find('.tutorial').removeClass('tutorial');
        this.$garage.find('.opened').css('display', 'none').removeClass('opened');

        if (!$(e.currentTarget).hasClass('open')) {
            $('.open').removeClass('open');
            var target = $(e.currentTarget).attr('class');
            this.trackMenu(target);
            $(e.currentTarget).addClass('open');
        } else {
            $('.open').removeClass('open');
        }
    };

    Garage.prototype.closeAll = function () {
        this.$garage.find('.open').removeClass('open');
        this.$garage.find('.tutorial').removeClass('tutorial');
        this.$market.find('.open').removeClass('open');
        this.$garage.find('.opened').css('display', 'none').removeClass('opened');

        if ($('.vendor').hasClass('active') !== true) {
            $('.vendor').hide();
        }

        $('.bubbleImg').hide();
    };

    Garage.prototype.astrocommScreenToggle = function(screen) {
        this.$astrocomm.find('.screen > div:not([class=screenToggle])').hide();
        this.$astrocomm.find('.screen > .' + screen).show();
    }

    Garage.prototype.visitSelect = function (a, b, c) {
        var targetName = $(b.target).data('target');
        var target = _.find(this.targets(), function(e, i) {
            return e.name().toLowerCase() == targetName;
        });

        this.visit(target);
        this.astrocommScreenToggle('planet');
        this.trackVisit(targetName);
    };

    Garage.prototype.visitOver = function(a,b,c) {
        var targetName = $(b.target).data('target');
        var target = _.find(this.targets(), function(e, i) {
            return e.name().toLowerCase() == targetName;
        });

        this.hover(target);
    };

    Garage.prototype.visitOut = function() {
        this.hover(null);
    };

    Garage.prototype.targetSelect = function () {
        this.target(this.visit());
        this.astrocommScreenToggle('chart');
        this.trackTarget(this.target().name());
    };

    Garage.prototype.openChart = function () {
        var self = this;
        this.astrocommScreenToggle('chart');
        this.trackChart('open');

        self.levelUpdate();
        self.initialFunction();
    };

    Garage.prototype.fuelProgress = function (a, e) {
        var self = this;
        var width = $(e.currentTarget).width();
        var offsetX = e.offsetX;
        var ammount = Math.round(((offsetX / width * 100) + 3) / 5, 0) * 5;
        var bought = ammount - self.fuelBase() - self.fuelSupply();

        if (bought >= 0) {
            $(e.currentTarget).find('div').width(ammount + '%');

            this.fuelBought(bought);
        }
    };

    Garage.prototype.chargeProgress = function (a, e) {
        var self = this;
        var width = $(e.currentTarget).width();
        var offsetX = e.offsetX;
        var ammount = Math.round(((offsetX / width * 100) + 3) / 5, 0) * 5;
        var bought = ammount - self.chargeBase() - self.chargeSupply();

        if (bought >= 0) {
            $(e.currentTarget).find('div').width(ammount + '%');

            this.chargeBought(bought);
        }
    };

    Garage.prototype.shieldProgress = function (a, e) {
        var self = this;
        var width = $(e.currentTarget).width();
        var offsetX = e.offsetX;
        var ammount = Math.round(((offsetX / width * 100) + 3) / 5, 0) * 5;
        var bought = ammount - self.shieldBase() - self.shieldSupply();

        if (bought >= 0) {
            $(e.currentTarget).find('div').width(ammount + '%');

            this.shieldBought(bought);
        }
    };

    Garage.prototype.shieldHeat = function() {
        this.shieldType('HEAT');
        this.$garage.find('.controls .shield .heat p').addClass('selected');
        this.$garage.find('.controls .shield .impact p').removeClass('selected');
    };

    Garage.prototype.shieldImpact = function() {
        this.shieldType('IMPACT');
        this.$garage.find('.controls .shield .heat p').removeClass('selected');
        this.$garage.find('.controls .shield .impact p').addClass('selected');
    };

    Garage.prototype.Deferred = function () {
        var self = this;
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };   

    Garage.prototype.updateInsertNewShip = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/insertNewShip",
            type: "POST",
            data: {}
        });
    };

    /*********************************************************************
    * GARAGE PARTS/ TOOLS/ STASH/ SHIP/ SHIP SELECTION/ GRAY MARKET ITEMS/ PILOT INFO
    */
    Garage.prototype.getGarageInfo = function () {
        return IREP.callApi({ url: 'swic6/garage' });
    };
   
    Garage.prototype.initialFunction = function () {
        var self = this;

        $.when(this.getGarageInfo(), this.Deferred()).then(function (items){
            //tools
            var UserTools = [];
            items[0].tools.forEach(function (e) {
                UserTools.push(new Garage.Item(self, e.category, e.name, e.description, e.imageUrl));
            });
            self.tools(UserTools);            

            //stash
            var UserStash = [];
            items[0].phantomParts.forEach(function (e) {
                UserStash.push(new Garage.Item(self, e.category, e.name, e.description, e.imageUrl));
            });
            self.stash(UserStash);

            //ship selection
            var UserShipSelection = [];
            items[0].ships.forEach(function (e) {
                UserShipSelection.push(new Garage.ShipSelection(self, e.id, e.name, e.description, e.icon, e.levelId))
            });
            self.shipSelection(UserShipSelection);

            if (items[0].ships.length !== 0) {
                self.astrocommScreenToggle('shipSelection');
                self.openScreen();                
            }

            //pilot information
            var UserInfo = [];
            UserInfo.push(new Garage.PilotObject(self, items[0].pilot.name, items[0].pilot.levelId, items[0].pilot.status,
            items[0].pilot.shipName, items[0].pilot.icon, items[0].pilot.totalPoints));

            self.pilotInfo(UserInfo);
            self.level(items[0].pilot.levelId);

            $(".vendor").hide();

            //show gray market items
            var UserMarket = [];
            if (items[0].grayMarketTools !== undefined && items[0].grayMarketTools !== 0) {
                $(".vendor").show();
                $('.bubbleImg').show();
                $(".vendor").addClass('active');
                var icon = 'GrayMktIcons-Bordered_0000_TOOL BUYOUT.jpg';
                var title = 'HANGAR TOOLS BUYOUT';
                var description = "So I found these laying around in one of the ring sections. Get em’ while they’re ‘HOT’! Buy ‘em all today, and from what I hear, you’ll get some sort of medal.";
                var id = 0;
                UserMarket.push(new Garage.Market(self, id, items[0].grayMarketTools, icon, title, description));
            }
            else if (items[0].grayMarketParts !== undefined && items[0].grayMarketParts.cost !== 0) {
                $(".vendor").show();
                $('.bubbleImg').show();
                $(".vendor").addClass('active');
                var icon = items[0].grayMarketParts.shipIcon;
                var title = items[0].grayMarketParts.shipName + ' PART BUYOUT';
                var description = 'No reason to work so hard to earn those parts. I have all the parts you need to complete your ship… if you’re willing to pay for it.';
                var id = 0;
                var cost = items[0].grayMarketParts.cost;
                UserMarket.push(new Garage.Market(self, id, cost, icon, title, description));
            }
            else if (items[0].garageAugmentedParts !== undefined && items[0].garageAugmentedParts[0] !== undefined) {
                $(".vendor").show();
                $('.bubbleImg').show();
                $(".vendor").addClass('active');
                items[0].garageAugmentedParts.forEach(function (e) {
                    UserMarket.push(new Garage.Market(self, e.id, e.cost, e.icon, e.name, e.description));
                });
            }
            self.market(UserMarket);
            self.selectedMarketItem(UserMarket[0]);
            if ($('.vendor-items').children()[0] !== undefined) {
                $('.vendor-items').children()[0].setAttribute("class", "vendor-item selected");
            }          

            //User didn't pay for towing     
            if (items[0].paidForTowing !== 0) {
                if (items[0].paidForTowing.success === false && items[0].paidForTowing.paidTowCost === false) {


                    self.mission(new Garage.Mission(self, items[0].paidForTowing.success, items[0].paidForTowing.fuel, items[0].paidForTowing.charge, items[0].paidForTowing.shield, items[0].paidForTowing.shieldType, 150, 'NONE', 0, 0, 0, items[0].paidForTowing.planetName, items[0].paidForTowing.level, items[0].paidForTowing.thruster));

                    self.openScreen();
                    self.astrocommScreenToggle('mission');
                    $('.bubbleImg').hide();
                    $('.vendor').show();
                    $('.bubble-tow').show();
                }
            }

            //garage ship
            if (typeof(items[0].ship) !== 'undefined') {
                var UserShip = [];
                UserShip.push(new Garage.Ship(self, items[0].ship.id, items[0].ship.name, items[0].ship.description, items[0].ship.icon));
                self.ship(UserShip);
            }
            else {               
                self.ship().length = 0;
                var UserShip = [];
                self.ship(UserShip);
                //parts
                var UserParts = [];
                items[0].parts.forEach(function (e) {
                    UserParts.push(new Garage.Item(self, e.category, e.name, e.description, e.imageUrl));
                });
                self.parts(UserParts);
            }

            //target
            var UserTarget = [];
            items[0].target.forEach(function (e) {
                UserTarget.push(new Garage.Target(self, e.id, e.name, e.description, e.icon, e.distance, e.level, e.numLandings, e.supply, e.chips, e.legendaryPart));
            });
            self.targets(UserTarget);

            //user supplies
            if (items[0].supplies !== undefined) {
                if (items[0].supplies.supply > 0) {
                    self.fuelSupply(10);
                    self.chargeSupply(5);
                    self.shieldSupply(10);
                    self.costSupply(25);
                }
                else {
                    self.fuelSupply(0);
                    self.chargeSupply(0);
                    self.shieldSupply(0);
                    self.costSupply(0);
                }
            }
        });
    };
    /*********************************************************************
     * INSERT PARTICIPANT INFO
     */
    Garage.prototype.insertUserInfo = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/insertParticipantInfo",
            type: "POST",
            data: {}
        });
    };

    /*********************************************************************
     * CHOOSE THE SHIP
     */
    Garage.prototype.chooseYourShip = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/selectShip",
            type: "POST",
            data: { shipId: self.id() }
        }).done(function () {
            self.garage.updateInsertNewShip();
            self.garage.levelUpdate();
            self.garage.initialFunction();                  
            self.garage.glowingBlue5();            
        });

        $('.shipSelection').fadeOut(300);
        $('.chart').fadeIn(300);
        self.garage.initialFunction();
        
    };   

    /*********************************************************************
  * LEVEL UPDATE
  */
    Garage.prototype.levelUpdate = function(){
        var self= this;

        IREP.callApi({
            url: "swic6/updateLevel",
            type: "POST",
            data: {}
        });
    };

    /*********************************************************************
     * INSERT NEW TOOLS AND PARTS
     */
    Garage.prototype.insertNewTools = function (){
        var self= this;
        IREP.callApi({
            url: "swic6/insertTool",
            type: "POST",
            data:{}
        });
    };    

    /*********************************************************************
     * 
     */
    Garage.prototype.launchShip = function () {
        var self = this;
       

        $.when(this.moveShipOffScreen(), self.getMissionStatus()).then(function (move, mission) {
            self.mission(mission);
            self.openScreen();
            self.astrocommScreenToggle('flight');
            return $.when(mission, self.delay(7000));
        }).then(function (data) {
            var mission = data;
            self.astrocommScreenToggle('mission');            

            if (mission.success()) {
                var soundFile = self.blue5Success[Math.floor(Math.random() * self.blue5Success.length)];
                self.playSound(soundFile);
                self.displayShip();
            }
            else {
                $('.bubbleImg').hide();
                $('.vendor').show();
                $('.bubble-tow').show();
                var soundFile = self.blue5Failure[Math.floor(Math.random() * self.blue5Failure.length)];
                self.playSound(soundFile);
            }
            self.initialFunction();            
            if (self.mission().success() === false) {
                $('.bubbleImg').hide();
                $('.vendor').show();
                $('.bubble-tow').show();
            }
        });
    };

    Garage.prototype.moveShipOffScreen = function() {
        var $ship = this.$garage.find('.ship img');
        return $ship.animate({ bottom: '100vh' }, 2500).promise();
    };

    Garage.prototype.getMissionStatus = function() {
        var self = this;

        var deferred = $.Deferred();

        var launch = {
            targetId: self.target().id(),
            fuel: self.fuel(),
            charge: self.charge(),
            shield: self.shield(),
            shieldType: self.shieldType(),
            targetLevel: self.target().level(),
            targetName: self.target().name()
        }
        IREP.callApi({ type: 'POST', url: 'swic6/garage/launch', data: launch }).done(function (response) {
            deferred.resolve((new Garage.Mission(self, response.success, response.fuel, response.charge, response.shield, response.shieldType, response.towingCost, response.icon, response.legendary, response.chips, response.supply, response.planetName, response.level, response.thruster)));
        });
        this.target(null);
        return deferred.promise();
    };

    Garage.prototype.payTheBill = function() {
        var self = this;
        if ($('.vendor').hasClass('active') !== true) {
            $('.vendor').hide();
        }

        $('.bubble-tow').hide();

        if (self.pilotInfo()[0].totalPoints() >= 150) {
            IREP.callApi({
                url: "swic6/towTheShip",
                type: "POST",
                data: {}
            }).done(function () {
                self.initialFunction();
            });

            this.astrocommScreenToggle('chart');
            this.displayShip();
        }
    };

    Garage.prototype.displayShip = function() {
        var self = this;
        var $ship = this.$garage.find('.ship img');
        $ship.css({ bottom: '5vh', opacity: 0 }).css({ opacity: 1 });
    };

    /*********************************************************************
     * 
     */

    Garage.Item = function (garage, type, name, description, icon) {
        this.garage = garage;

        this.type = ko.observable(type);
        this.name = ko.observable(name);
        this.description = ko.observable(description);
        this.icon = ko.observable(icon);

        this.timeoutId = 0;
    }  

    Garage.Item.prototype.mouseOver = function () {
        var self = this;
        this.timeoutId = setTimeout(function () {
            self.garage.selectedTool(self);
            self.garage.$garage.find('.tools .summary').addClass('open');
        }, hoverTimeout);
    };

    Garage.Item.prototype.mouseOut = function () {
        this.garage.$garage.find('.tools .summary').removeClass('open');
        this.garage.selectedTool(null);
        clearTimeout(this.timeoutId);
    };

    Garage.Item.prototype.mouseOverStash = function () {
        var self = this;
        this.timeoutId = setTimeout(function () {
            self.garage.selectedStash(self);
            self.garage.$garage.find('.stash .summary').addClass('open');
        }, hoverTimeout);
    };

    Garage.Item.prototype.mouseOutStash = function () {
        this.garage.$garage.find('.stash .summary').removeClass('open');
        this.garage.selectedStash(null);
        clearTimeout(this.timeoutId);
    };

    Garage.Item.prototype.mouseOverPart = function() {
        var self = this;
        this.timeoutId = setTimeout(function () {
            self.garage.selectedPart(self);
            self.garage.$garage.find('.status .summary').addClass('open');
        }, hoverTimeout);
    };

    Garage.Item.prototype.mouseOutPart = function() {
        this.garage.$garage.find('.status .summary').removeClass('open');
        this.garage.selectedPart(null);
        clearTimeout(this.timeoutId);
    };

    Garage.Ship = function(garage, id, name, description, icon) {
        this.garage = garage;

        this.id = ko.observable(id);
        this.name = ko.observable(name);
        this.description = ko.observable(description);
        this.icon = ko.observable(icon);
    };

    Garage.Target = function (garage, id, name, description, icon, distance, level, numLandings, supply, chips, legendaryPart) {
        this.garage = garage;

        this.id = ko.observable(id);
        this.name = ko.observable(name);
        this.description = ko.observable(description);
        this.icon = ko.observable(icon);
        this.distance = ko.observable(distance);
        this.level = ko.observable(level);
        this.numLandings = ko.observable(numLandings);
        this.supply = ko.observable(supply);
        this.chips = ko.observable(chips);
        this.legendaryPart = ko.observable(legendaryPart);
    };

    Garage.ShipSelection = function (garage, id, name, description, icon, levelId) {
        this.garage = garage;
        this.id = ko.observable(id);
        this.name = ko.observable(name);
        this.description = ko.observable(description);
        this.icon = ko.observable(icon);
        this.levelId = ko.observable(levelId);
    };

    Garage.PilotObject = function (garage, name, levelId, status, shipName, icon, totalPoints) {
        this.garage = garage;
        this.name = ko.observable(name);
        this.levelId = ko.observable(levelId);
        this.status = ko.observable(status);
        this.shipName = ko.observable(shipName);
        this.icon = ko.observable(icon);
        this.totalPoints = ko.observable(totalPoints);
    };

    Garage.Mission = function(garage, success, fuel, charge, shield, shieldType, towingCost, icon, legendary, chips, supply, planetName, level, thruster) {
        this.garage = garage;

        this.success = ko.observable(success);
        this.fuel = ko.observable(fuel);
        this.charge = ko.observable(charge);
        this.shield = ko.observable(shield);
        this.shieldType = ko.observable(shieldType);
        this.towingCost = ko.observable(towingCost);

        this.icon = ko.observable(icon);
        this.legendary = ko.observable(legendary);
        this.chips = ko.observable(chips);
        this.supply = ko.observable(supply);
        this.planetName = ko.observable(planetName);
        this.level = ko.observable(level);
        this.thruster = ko.observable(thruster);
    }

    Garage.Market = function (garage, id, cost, icon, title, description) {
        this.garage = garage;

        this.id = ko.observable(id);
        this.cost = ko.observable(cost);
        this.icon = ko.observable(icon);
        this.title = ko.observable(title);
        this.description = ko.observable(description);
    }

    Garage.Market.prototype.selectItem = function (data, event) {
        var self = this;

        event = event || window.event;
        var target = event.target || event.srcElement;

        this.garage.selectedMarketItem(null);
        self.garage.selectedMarketItem(self);
        $('.vendor-item').removeClass('selected');
        // var targetEvent = event.target.parentElement;
        var targetEvent = target.parentElement;
        $(targetEvent).addClass('selected');
    };

    Garage.Market.prototype.purchaseItemGrayMarket = function () {
        var self = this;
        var str = self.title();

        if (self.cost() <= self.garage.pilotInfo()[0].totalPoints()) {
            if (self.title() === 'HANGAR TOOLS BUYOUT') {
                IREP.callApi({
                    url: "swic6/insertPurchasedItems",
                    type: "POST",
                    data: {
                        itemId: 0,
                        augmented1: 0,
                        augmented2: 0,
                        type: "Tools",
                        incentiveId: 40450,
                        incentiveCode: '2015SWIC6_Hangar',
                        description: 'SWIC6_HANGAR'
                    }
                }).done(function () {
                    $(".vendor").hide();
                    self.garage.initialFunction();

                    $('#market').css('display', 'none');
                    $('#garage').css('display', 'block');
                });
            }
            else if (str.search("PART BUYOUT") !== -1) {
                IREP.callApi({
                    url: "swic6/insertPurchasedItems",
                    type: "POST",
                    data: {
                        itemId: 0,
                        augmented1: 0,
                        augmented2: 0,
                        type: "Parts",
                        incentiveId: 40450,
                        incentiveCode: '2015SWIC6_Hangar',
                        description: 'SWIC6_HANGAR'
                    }
                }).done(function () {
                    $(".vendor").hide();
                    self.garage.updateInsertNewShip();
                    self.garage.initialFunction();


                    $('#market').css('display', 'none');
                    $('#garage').css('display', 'block');
                });
            }
            else {
                var augmented1 = 0;
                var augmented2 = 0;
                if (str.search("SOLAR") !== -1) {
                    augmented1 = 1;

                    IREP.callApi({
                        url: "swic6/insertPurchasedItems",
                        type: "POST",
                        data: {
                            itemId: self.id(),
                            augmented1: augmented1,
                            augmented2: augmented2,
                            type: "AugmentedItemsSolar",
                            incentiveId: 40450,
                            incentiveCode: '2015SWIC6_Hangar',
                            description: 'SWIC6_HANGAR'
                        }
                    }).done(function () {
                        $(".vendor").hide();
                        self.garage.initialFunction();

                        $('#market').css('display', 'none');
                        $('#garage').css('display', 'block');
                    });
                }
                if (str.search("THRUST") !== -1) {
                    augmented2 = 1;

                    IREP.callApi({
                        url: "swic6/insertPurchasedItems",
                        type: "POST",
                        data: {
                            itemId: self.id(),
                            augmented1: augmented1,
                            augmented2: augmented2,
                            type: "AugmentedItemsThrust",
                            incentiveId: 40450,
                            incentiveCode: '2015SWIC6_Hangar',
                            description: 'SWIC6_HANGAR'
                        }
                    }).done(function () {
                        $(".vendor").hide();
                        self.garage.initialFunction();

                        $('#market').css('display', 'none');
                        $('#garage').css('display', 'block');
                    });
                }

                if (str.search("STRIPES") !== -1) {
                    IREP.callApi({
                        url: "swic6/insertPurchasedItems",
                        type: "POST",
                        data: {
                            itemId: self.id(),
                            augmented1: augmented1,
                            augmented2: augmented2,
                            type: "AugmentedItemsPaint",
                            incentiveId: 40450,
                            incentiveCode: '2015SWIC6_Hangar',
                            description: 'SWIC6_HANGAR'
                        }
                    }).done(function () {
                        $(".vendor").hide();
                        self.garage.initialFunction();

                        $('#market').css('display', 'none');
                        $('#garage').css('display', 'block');
                    });
                }

            }
        }
    };

    return Garage;
}());